var React = require('react');

function Videos48 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.57178 32.5718V25.8186C8.57178 17.2403 15.4794 10.2861 24.0004 10.2861C32.5213 10.2861 39.4289 17.2403 39.4289 25.8186V32.5718","stroke":"#EA6C13","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.1429 36H15.4286C14.4819 36 13.7144 35.1046 13.7144 34V26C13.7144 24.8954 14.4819 24 15.4286 24H17.1429V36Z","stroke":"#EA6C13","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.8571 36H32.5714C33.5181 36 34.2856 35.1046 34.2856 34V26C34.2856 24.8954 33.5181 24 32.5714 24H30.8571V36Z","stroke":"#EA6C13","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Videos48.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Videos48;

Videos48.default = Videos48;
